import React, { ReactNode, type FC } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading3 from "../../../designsystem/typography/KC-Heading/KC_Heading3";
import KC_Button, {
  KC_ButtonSize
} from "../../../designsystem/KC_Button/KC_Button";
import KC_Text from "../../../designsystem/typography/KC_Text/KC_Text";
import { KC_Text_Sizes, KC_Weights } from "../../../designsystem/ds_commons";
import "./styles.scss";
import TwemojiWrapper from "../../TwemojiWrapper/TwemojiWrapper";

interface Props {
  headerText: string;
  bodyText: ReactNode | string;
  buttonText?: string;
  onClick?: () => void;
  additionalContent?: ReactNode;
}

const PostPaymentModal: FC<Props & NiceModalHocProps> = NiceModal.create<Props>(
  (props) => {
    const modal = useModal();

    const handleConfirm = (value: boolean) => {
      modal.resolve(value);
      void modal.hide();
    };

    return (
      <KC_Modal_2
        id="post-payment-modal"
        isOpen={modal.visible}
        onClose={modal.hide}
        hideCloseButton={true}
        header={
          <div className={"w-100 py-2 px-3"}>
            <TwemojiWrapper isMediumText={true}>
              <KC_Heading3 className="text-center" text={props.headerText} />
            </TwemojiWrapper>
          </div>
        }
        footer={
          <div className="d-flex flex-grow-1 align-items-center">
            <KC_Button
              id="post-payment-confirm"
              isPrimary={true}
              onClick={() => {
                if (props.onClick) {
                  props.onClick();
                }
                handleConfirm(true);
              }}
              size={KC_ButtonSize.Large}
              text={`${props.buttonText ? props.buttonText : "OK"}`}
              className="d-flex"
            />
          </div>
        }
      >
        <div
          className="p-4 text-center d-flex flex-column justify-content-center"
          style={{ minHeight: 100 }}
        >
          <KC_Text
            size={KC_Text_Sizes.md}
            weight={KC_Weights.reg}
            text={props.bodyText}
          />
          {!!props.additionalContent ? props.additionalContent : null}
        </div>
      </KC_Modal_2>
    );
  }
);

export default PostPaymentModal;
